//import { isSafari } from 'react-device-detect';

export const objectGet = ( object, key, emptyval ) => {
    if( !object ){
        console.info(`ObjectGet: object ${object} é nulo`);
        return false
    }
    else if( typeof object === 'string' ){
        console.info(`ObjectGet: object ${object} é uma string`);
        return false
    }
    if( object[key] !== undefined && object[key] !== false && object[key] !== null && object[key] !== '' ){
        return object[key]
    }
    else {
        return emptyval !== undefined ? emptyval : false
    }
}

export const hasParent = ( element, classname ) => {
    if( element.classList !== undefined && element.classList.contains( classname ) ) return true
    return element.parentNode && hasParent( element.parentNode, classname )
}

export function getBasename(){
    if( window.siteKey.indexOf( '<' ) === 0 ){
        let 
            peaces = window.location.pathname.split( '/' ),
            site = peaces.shift()
        ;
        if( site === '' ){
            site = peaces.shift();
        }
        return site;
    }
    else {
        return window.siteKey;
    }
};

export function imageURL( url ){
    return url;
}

export function normalizeString( str ){

    str = str.replace( /[ÀÁÂÃÄÅ]/, 'A' )
    str = str.replace( /[àáâãäå]/, 'a' )
    str = str.replace( /[ÈÉÊË]/, 'E' )
    str = str.replace( /[í]/, 'i' )
    str = str.replace( /[ôõó]/, 'o' )
    str = str.replace( /[ú]/, 'u' )
    str = str.replace( /[Ç]/, 'C' )
    str = str.replace( /[ç]/, 'c' )

    return str.replace( /[^a-z0-9 ]/gi, '' )

}

export function onlyNumbers( string ){
    return string.replace( /\D/g, '' )
}

export function stringSearch( source, string ){

    source = normalizeString( source.toUpperCase() );
    string = normalizeString( string.toUpperCase() );

    return source.indexOf( string ) >= 0;

}

// URL para posts do Blog BBP
export function BlogBBPLink( item ){

    const type = item.type !== undefined ? item.type : item.post_type;
    const type_slug = ( type === 'curadoria' ? 'curadoria' : item.custom.editoria.slug );
    
    return '/blogbbp/' + type_slug + '/' + ( type === 'curadoria' ? item.slug : item.custom.slug ); 
}

export function validateEmail( email ){

    let lastAtPos = email.lastIndexOf( '@' );
    let lastDotPos = email.lastIndexOf( '.' );

    if( !( lastAtPos < lastDotPos && lastAtPos > 0 && email.indexOf( '@@' ) === -1 && lastDotPos > 2 && ( email.length - lastDotPos ) > 2 ) ){
        return false;
    }

    return true;

}

export const validatePhone = ( tel ) => {

    const digits = tel.replace(/\D/g, '');

    if (digits.length < 10 || digits.length > 11) return false;

    const ddd = parseInt(digits.substring(0, 2));
    const dddsValidos = [
        11,12,13,14,15,16,17,18,19,
        21,22,24,
        27,28,
        31,32,33,34,35,37,38,
        41,42,43,44,45,46,
        47,48,49,
        51,53,54,55,
        61,62,63,64,65,66,67,68,69,
        71,73,74,75,77,
        79,
        81,82,83,84,85,86,87,88,89,
        91,92,93,94,95,96,97,98,99,
    ];

    if (!dddsValidos.includes(ddd)) return false;

    // Celular com 11 dígitos deve começar com 9
    if (digits.length === 11 && digits[2] !== '9') return false;

    return true;
}

// Str pad
function pad( number ){
    return number.toString().length === 2 ? number.toString() : ( '0' + number.toString() );
}

// Formating date
export function formatDate( date ){
    return pad( date.dayOfMonth ) + '/' + pad( date.monthValue ) + '/' + date.year;
}

export function maskCep( cep ){
    
    // Normalize and format
    cep = cep.toString();
    if( cep.length === 8 ){
        var peaces = cep.split( '' );
        cep = peaces.slice( 0, 2 ).join( '' ) + '.' + peaces.slice( 2, 5 ).join( '' ) + '-' + peaces.slice( 5 ).join( '' );
    }
    return cep;
}

export function validateCEP( cep ){

    // Normalize and format
    cep = maskCep( cep );

    // Validate
    var objER = /^[0-9]{2}.[0-9]{3}-[0-9]{3}$/;
    return objER.test( cep );

}


export const ClearMoney = value => {
    
    if( value === '' ) return 0;

    value = value
        .toString()
        // Remove unity
        .replace( 'R$', '' )
        // Remove sapces
        .split(' ').join('')
        // Remove dots
        .split( '.' ).join( '' )
        // Change commas to dots
        .split( ',' ).join( '.' )
    ;
    value = parseFloat( value );
    
    return value <= 0 ? 0 : value;

}

export const formatMoney = ( value ) => {

    // Fixed big decimals
    if( typeof( value ) === 'number' ){
        value = value.toFixed(2);
    }

    // Set Convert
    value = value.toString().replace('.', '').replace(',', '').replace(/\D/g, '');
    if( value === '' ) value = '0';

    const options = { minimumFractionDigits: 2 }
    const result = new Intl.NumberFormat( 'pt-BR', options ).format(
        parseFloat( value ) / 100
    )
    
    return result === '0,00' ? '' : 'R$ ' + result;

}

export const stringToFloat = ( string ) => {
    return string.replace( 'R$ ', '' ).split( '.' ).join( '' );
}

export function cpfMask( value ){

    if( value === null || value === false || value === '' ) return '';

    return value
      .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
      .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1') // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
}

export function emailMask( email ){

    if( !email || email === '' ) return '';

    var maskedEmail = email.replace(/([^@.])/g, "*").split( '' );
    var previous = '';
    
    for( let i = 0; i < maskedEmail.length; i++ ){
        if( i <= 1 || previous === "." || previous === '@' ){
            maskedEmail[ i ] = email[ i ];
        }
        previous = email[ i ];
    }

    return maskedEmail.join( '' );

}

// Phone mask
export const phoneMask = ( value, key ) => {
    
    let stringValue = onlyNumbers(value.toString())
    
    if( stringValue.length === 1 ){
        return `(${stringValue}`
    }
    else {

        let phone = '';

        if( stringValue.length == 0 ){
            return phone;
        }

        phone = '(' + stringValue.substring(0, 2);

        if( stringValue.length > 2 || key !== null ){
            phone += ') '
        }

        const startLast = ( stringValue.length === 11 ? 7 : 6 )

        phone += stringValue.substring( 2, startLast )

        if( stringValue.length == 6 && key === null ){
            return phone
        }

        if( stringValue.length >= startLast ){
            phone += '-' + stringValue.substring( startLast )
        }
        
        return phone
    
    }

} 

export function calculaIdade( data ){

    let peaces, dia, mes, ano;
    if( data.indexOf( '/' ) > 0 ){
        peaces = data.split( '/' );
        dia = peaces[ 0 ];
        mes = peaces[ 1 ];
        ano = peaces[ 2 ];
    }
    else {
        peaces = data.split( '-' );
        dia = peaces[ 2 ];
        mes = peaces[ 1 ];
        ano = peaces[ 0 ];
    } 

    var d = new Date(),
        ano_atual = d.getFullYear(),
        mes_atual = d.getMonth() + 1,
        dia_atual = d.getDate(),
        ano_aniversario = +ano,
        mes_aniversario = +mes,
        dia_aniversario = +dia,
        quantos_anos = ano_atual - ano_aniversario
    ;

    if( mes_atual < mes_aniversario || ( mes_atual === mes_aniversario && dia_atual < dia_aniversario ) ){
        quantos_anos--;
    }

    return quantos_anos < 0 ? 0 : quantos_anos;

}

export default getBasename;
